import { useEffect, useState } from "react";
import { api, AdminError } from "../adminClient.js";

interface QuizMeta { quizId: string; title: string; setNumber: number; questionCount: number; updatedAt: string; }

const SAMPLE = `{
  "title": "CNA Quiz - Set 1",
  "setNumber": 1,
  "questions": [
    { "prompt": "Question text?", "choices": [
        {"key":"A","text":"Option A"},
        {"key":"B","text":"Option B"},
        {"key":"C","text":"Option C"},
        {"key":"D","text":"Option D"} ],
      "correctKey": "B" }
  ]
}`;

export default function QuizManagerPage() {
  const [items, setItems] = useState<QuizMeta[]>([]);
  const [error, setError] = useState("");
  const [quizId, setQuizId] = useState("set-1");
  const [json, setJson] = useState("");
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState("");

  function load() {
    api<{ items: QuizMeta[] }>("/admin/quizzes")
      .then((d) => setItems(d.items))
      .catch((e) => setError(e instanceof AdminError ? e.message : "Failed to load quizzes"));
  }
  useEffect(load, []);

  async function importQuiz() {
    setBusy(true); setError(""); setMsg("");
    let body: unknown;
    try { body = JSON.parse(json); }
    catch { setError("Content isn't valid JSON."); setBusy(false); return; }
    try {
      const r = await api<{ questionCount: number }>(`/admin/quizzes/${quizId.trim()}`, { method: "PUT", body });
      setMsg(`Imported ${r.questionCount} questions into ${quizId.trim()}.`);
      setJson(""); load();
    } catch (e) {
      setError(e instanceof AdminError ? e.message : "Import failed");
    } finally {
      setBusy(false);
    }
  }

  // Import/replace is hidden from the UI for now (functionality kept intact);
  // flip to true to expose the import card again.
  const SHOW_IMPORT = false;

  return (
    <>
      <h1>Quizzes</h1>
      <p className="subhead">The 4 static quiz sets students take weekly (Thu 7 PM - Fri 9 PM).</p>
      {error && <div className="login-err" style={{ marginBottom: 12 }}>{error}</div>}

      {items.length === 0 ? (
        <div className="card empty">No quiz sets loaded yet.</div>
      ) : (
        <div className="card pad" style={{ marginBottom: 18 }}>
          <table>
            <thead><tr><th>Quiz</th><th>Title</th><th>Questions</th><th>Updated</th></tr></thead>
            <tbody>
              {items.sort((a, b) => a.setNumber - b.setNumber).map((q) => (
                <tr key={q.quizId}>
                  <td><div className="nm">{q.quizId}</div></td>
                  <td>{q.title}</td>
                  <td>{q.questionCount}</td>
                  <td className="sub">{q.updatedAt ? new Date(q.updatedAt).toLocaleDateString() : "-"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {SHOW_IMPORT && (
      <div className="card pad">
        <div className="alabel" style={{ marginTop: 0 }}>Import / replace a quiz set</div>
        <div className="g2form" style={{ gridTemplateColumns: "200px 1fr" }}>
          <label className="fld"><span className="alabel">Quiz id</span>
            <input className="ainput" value={quizId} onChange={(e) => setQuizId(e.target.value)} placeholder="set-1" />
          </label>
        </div>
        <div className="alabel">Content (JSON)</div>
        <textarea className="ainput abody-input" value={json} onChange={(e) => setJson(e.target.value)} placeholder={SAMPLE} style={{ minHeight: 240, fontFamily: "ui-monospace, monospace" }} />
        <div className="actions" style={{ marginTop: 12 }}>
          <button className="rbtn coral" disabled={busy || !json.trim()} onClick={importQuiz}>{busy ? "Importing..." : "Import quiz"}</button>
          {msg && <span className="sub savedcue" style={{ alignSelf: "center" }}>{msg}</span>}
        </div>
      </div>
      )}
    </>
  );
}
